import { useDisclosure } from '@mantine/hooks';
import { FiMaximize } from 'react-icons/fi';

import { Box, Button, Flex, Image, Modal, Skeleton, Stack, Text } from '@highlight-cp/core-ui';

import classes from './asset-thumbnail.module.css';
import { THUMBNAIL_SIZE } from './constants';
import type { AssetThumbnailProps } from './types';

const AssetThumbnail = ({
  asset,
  stimulusName,
  displayStimulusLabel,
  size,
}: AssetThumbnailProps) => {
  const { url, name } = asset;
  const [isOpen, { open, close }] = useDisclosure(false);
  const thumbnailSize = size ?? THUMBNAIL_SIZE;

  return (
    <>
      <Stack gap={0} align="center">
        <Button variant="subtle" onClick={open} h={thumbnailSize} p={0}>
          <Box component="span" className={classes.inner}>
            <Image
              src={url}
              alt={name ?? ''}
              width={thumbnailSize}
              height={thumbnailSize}
              radius="md"
            />
            <Flex className={classes.maximize} align="center" justify="center">
              <FiMaximize className={classes.maximizeIcon} size={20} />
            </Flex>
          </Box>
        </Button>
        {stimulusName && displayStimulusLabel && (
          <Text span size="sm" fw="bold" lineClamp={2} title={stimulusName}>
            {stimulusName}
          </Text>
        )}
      </Stack>
      <Modal opened={isOpen} onClose={close} size="xl" title={stimulusName}>
        <Image src={url} alt={name ?? ''} radius="md" />
      </Modal>
    </>
  );
};

const AssetThumbnailSkeleton = ({ size }: { size?: number }) => (
  <Skeleton width={size ?? THUMBNAIL_SIZE} height={size ?? THUMBNAIL_SIZE} radius="md" />
);

AssetThumbnail.Skeleton = AssetThumbnailSkeleton;

export default AssetThumbnail;
